import { commonTranslationKeys, PromiseVoidFunction, useInterpolatedTranslationKey } from '@dreryk/react-common';
import { Link, ModalWidth, RemoveIcon, ShowModalEventInterceptor, Tooltip } from '@dreryk/react-components';

import { serviceProvidingLocationTranslationKeys } from '../../../translations';

type ServiceProvidingLocationRemoveLinkProps = {
   readonly locationCode: string;
   readonly serviceProvidingLocationName: string | null;
   readonly onRemoved: PromiseVoidFunction;
   readonly disabled: boolean;
};

export const ServiceProvidingLocationRemoveLink = (props: ServiceProvidingLocationRemoveLinkProps): JSX.Element => {
   return (
      <ShowModalEventInterceptor
         shouldShowModal
         modalWidth={ModalWidth.NORMAL}
         testId={'removeServiceProvidingLocation'}
         title={serviceProvidingLocationTranslationKeys.removingServiceProvidingLocation}
         content={useInterpolatedTranslationKey(
            serviceProvidingLocationTranslationKeys.doYouWantRemoveYourServiceProvidingLocation,
            {
               serviceProvidingLocationName: props.serviceProvidingLocationName,
               locationCode: props.locationCode,
            }
         )}
         confirmationButtonLabel={commonTranslationKeys.remove}
      >
         <Tooltip
            content={
               props.disabled
                  ? serviceProvidingLocationTranslationKeys.minimumOneServiceProvidingLocation
                  : commonTranslationKeys.remove
            }
            testId={'removeServiceProvidingLocation'}
         >
            <Link
               onClick={props.onRemoved}
               disabled={props.disabled}
               testId={'removeServiceProvidingLocation'}
               icon={<RemoveIcon />}
            />
         </Tooltip>
      </ShowModalEventInterceptor>
   );
};
